import { render, staticRenderFns } from "./IconLeftTop1.vue?vue&type=template&id=4539e6bc&"
import script from "./IconLeftTop1.vue?vue&type=script&lang=js&"
export * from "./IconLeftTop1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4539e6bc')) {
      api.createRecord('4539e6bc', component.options)
    } else {
      api.reload('4539e6bc', component.options)
    }
    module.hot.accept("./IconLeftTop1.vue?vue&type=template&id=4539e6bc&", function () {
      api.rerender('4539e6bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/PopupButtonPositions/IconLeftTop1.vue"
export default component.exports